import React, { useEffect, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { UFDate } from "../../../components/Common/Fields/Input"
import moment from "moment"
import { isEmpty } from "lodash"
import { useForm } from "react-hook-form"
import {
  downloadTrialBalance,
  fetchFinanceTrialBalance,
} from "../../../services/finance/finance"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Logo from "../../../assets/images/logo.svg"
import { useLocation, useNavigate } from "react-router-dom"
import arrow from "../../../assets/icons/arrow.svg"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import NestedAccordion from "../../../components/Common/AccordionTable"

const TrialBalance = ({ fromDashboard }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Trial Balance${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [fetchedDataFilter, setFetchedDataFilter] = useState()
  const [debitTotal, setDebitTotal] = useState(0)
  const [creditTotal, setCreditTotal] = useState(0)
  const [refresh, setRefresh] = useState(0)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const { control, watch, reset } = useForm()

  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      const responce = await fetchFinanceTrialBalance({
        params: `${startDate ? `&start_date=${startDate}` : ""}${`&sortOrder=asc`}${
          endDate ? `&end_date=${endDate}` : ""
        }`,
      })
      setFetchedData(responce)
    }
    fetchData()
  }, [startDate, endDate, refresh])

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    setStartDate(fromDate)
    setEndDate(toDate)
  }
  const handleStartDateChange = e => {
    setStartDate(e.target.value)
  }
  const handleEndDateChange = e => {
    setEndDate(e.target.value)
  }

  const assetColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <span className="fw-500 fs-14">{item?.group_name}</span>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
  ]
  const liabilityColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <span className="fw-500 fs-14">{item?.group_name}</span>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
  ]
  const incomeColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <span className="fw-500 fs-14">{item?.group_name}</span>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
  ]
  const expenseColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <span className="fw-500 fs-14">{item?.group_name}</span>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
  ]

  const assetSubColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance-ledger-acc`, {
              state: { item, startDate, endDate },
            })
          }
          className="pointer fw-bold ps-3"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: "Debit Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "Credit Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange,
                desimalrange
              )}`
            : "-"}
        </div>
      ),
    },
  ]

  const filterNonZeroEntries = entries =>
    entries?.filter(
      entry =>
        (Number(entry.debit) ?? 0) !== 0 || (Number(entry.credit) ?? 0) !== 0
    )

  // const filterNonZeroEntries = entries =>
  //   entries
  //     ?.map(entry => {
  //       const filteredLedgers = entry.ledgers?.filter(
  //         l => Number(l.debit || 0) !== 0 || Number(l.credit || 0) !== 0
  //       );

  //       const hasNonZeroGroup =
  //         Number(entry.debit || 0) !== 0 || Number(entry.credit || 0) !== 0;

  //       if (hasNonZeroGroup || filteredLedgers.length > 0) {
  //         return {
  //           ...entry,
  //           ledgers: filteredLedgers,
  //         };
  //       }

  //       return null;
  //     })
  //     .filter(Boolean);

  useEffect(() => {
    const filteredData = {
      asset: filterNonZeroEntries(fetchedData?.data.asset),
      expense: filterNonZeroEntries(fetchedData?.data.expense),
      income: filterNonZeroEntries(fetchedData?.data.income),
      liability: filterNonZeroEntries(fetchedData?.data.liability),
    }
    setFetchedDataFilter(filteredData)
  }, [fetchedData])

  const reduceBalance = (assets, amount) => {
    // Reduce the balance of each asset and sum them up
    const total = assets.reduce((sum, asset) => {
      return sum + (asset.balance - amount) // Reduce the balance and accumulate
    }, 0)

    return total // Return the total balance after reduction
  }

  // const getTotalValue = (data, key) => {
  //   console.log(`data:`, data)

  //   return data.reduce((total, item) => {
  //     return total + (Number(item?.[key]) || 0) // Add the specified key's value, defaulting to 0 if undefined
  //   }, 0)
  // }

  // useEffect(() => {
  //   if (fetchedData) {
  //     const totalDebit = Object.keys(fetchedData?.data).reduce((sum, key) => {
  //       return sum + getTotalValue(fetchedData?.data[key], "debit")
  //     }, 0)

  //     const totalCredit = Object.keys(fetchedData?.data).reduce((sum, key) => {
  //       return sum + getTotalValue(fetchedData?.data[key], "credit")
  //     }, 0)

  //     setDebitTotal(totalDebit)
  //     setCreditTotal(totalCredit)

  //     console.log(`totalDebit:`, totalDebit)
  //     console.log(`totalCredit:`, totalCredit)
  //   }
  // }, [fetchedData])

  const getTotalDifference = data => {
    return data.reduce(
      (totals, item) => {
        const debit = Number(item?.debit) || 0
        const credit = Number(item?.credit) || 0
        
        const diff = debit - credit
        console.log("Debit:", debit, " : Credit:", credit, " diff:", diff)
        if (debit > credit) {
          totals.debitSide += diff
        } else {
          totals.creditSide += diff
        }

        return totals
      },
      { debitSide: 0, creditSide: 0 }
    )
  }

  useEffect(() => {
    if (fetchedData) {
      let totalDebit = 0
      let totalCredit = 0

      // Object.keys(fetchedData?.data).forEach(key => {
        // const { debitSide, creditSide } = getTotalDifference(
        //   fetchedData.data[key]
        // )
        let debitSide = fetchedData?.total_debit
        let creditSide = fetchedData?.total_credit
        totalDebit += debitSide
        totalCredit += creditSide
      // })
console.log("totalcredt:", totalCredit)
      const opBal = fetchedData?.opening_balance_difference
      console.log("opBal:", opBal)

      const debitTotalWithOP = fetchedData?.opening_balance_type == "debit" ? Math.abs(Number(totalDebit)) + Math.abs(Number(opBal)) : Math.abs(Number(totalDebit))
      const creditTotalWithOP = fetchedData?.opening_balance_type == "credit" ? Math.abs(Number(totalCredit)) + Math.abs(Number(opBal)) : Math.abs(Number(totalCredit))
      

      setDebitTotal(debitTotalWithOP)
      setCreditTotal(creditTotalWithOP)

      console.log("debitTotalWithOP:", debitTotalWithOP)
      console.log("creditTotalWithOP:", creditTotalWithOP)
    }
  }, [fetchedData])

  const handleReset = () => {
    reset()
    setStartDate("")
    setEndDate("")
    setRefresh(refresh + 1)
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {!fromDashboard ? (
                <>
                  <Breadcrumbs
                    title="Finance"
                    breadcrumbObject={[
                      { title: "Finance", link: "/finance" },
                      { title: crumb || "Reports", link: "#" },
                      {
                        title: "Trial Balance",
                        link: "/finance-trial-balance",
                      },
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="pe-2 d-flex align-items-center">
              <div
                className="export-div pointer reset-img me-2 py-2"
                onClick={() => handleReset()}
              >
                <img src={resetIcon} height={15} width={15} className="" />{" "}
              </div>
              <div className="me-2">
                <UFDate
                  control={control}
                  name="start_date"
                  placeholder="Start Date"
                  mode="single"
                  onDateChange={([date]) =>
                    setStartDate(date ? moment(date).format("YYYY-MM-DD") : "")
                  }
                  maxDate={endDate || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              {/* End Date */}
              <div className="me-2">
                <UFDate
                  control={control}
                  name="end_date"
                  placeholder="End Date"
                  mode="single"
                  onDateChange={([date]) =>
                    setEndDate(date ? moment(date).format("YYYY-MM-DD") : "")
                  }
                  minDate={startDate || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              <>
                <div className="me-2">
                  <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                    Download
                  </span>
                </div>
                <UncontrolledPopover
                  placement="bottom"
                  target={`PopoverLegacy-1`}
                  trigger="legacy"
                >
                  <PopoverBody>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadTrialBalance({
                          params: `pdf=true${
                            startDate ? `&start_date=${startDate}` : ""
                          }${endDate ? `&end_date=${endDate}` : ""}`,
                          type: "pdf",
                          fileName: "trial_balance.pdf",
                        })
                      }
                    >
                      PDF
                    </div>
                    {/* <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadTrialBalance({
                          params: `excel=true${
                            startDate ? `&start_date=${startDate}` : ""
                          }${endDate ? `&end_date=${endDate}` : ""}`,
                          type: "excel",
                          fileName: "trial_balance.xlsx",
                        })
                      }
                    >
                      Excel
                    </div> */}
                  </PopoverBody>
                </UncontrolledPopover>
              </>
            </div>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {/* <div className="d-flex justify-content-between align-items-center my-2 me-2">
              <div className="filter-wrapper-balance"></div>
              <div className="d-flex">
                <UFDate
                  control={control}
                  name={"req_date"}
                  placeholder={"Date"}
                  mode={"range"}
                  onDateChange={e => handleRequestdate(e)}
                />
              </div>
            </div> */}
            {/* <hr className="table-divide" /> */}
            {/* <div className="d-flex justify-content-between">
              <div className="purchase-view-div-report"> */}
            <div className="d-flex justify-content-between align-items-center mt-2 py-2 px-2">
              <img className="view-logo" src={Logo} alt="logo" />

              <div className="payroll-total edittheamtitle">Trial Balance</div>
              <div className="fs-14">
                {startDate && endDate
                  ? `${moment(startDate).format("DD-MM-YYYY")} -
                    ${moment(endDate).format("DD-MM-YYYY")}`
                  : `As of ${moment().format("DD-MM-YYYY")}`}
              </div>
            </div>
            <hr className="table-divide" />
            <table className="estimation-table">
              <thead>
                <tr>
                  <th className="w-50">Account Name</th>
                  <th className="w-25 text-end pe-5">Debit (AED)</th>
                  <th className="w-25 text-end pe-5">Credit (AED)</th>
                </tr>
              </thead>
            </table>
            {console.log(`fetchedDataFilter`, fetchedDataFilter)
            }
            <div className="trial-scroll">
              {fetchedDataFilter?.asset?.length ? (
                <div className="ps-4 pb-3 dotted-border-y">
                  <div className="d-flex justify-content-between">
                    <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                      Assets
                    </div>
                  </div>
                  <div className="ms-2">
                    <Row className="mt-2 ever-rise-table reportTable trial-table">
                      <Col xs={12}>
                        {fetchedDataFilter?.asset && (
                          <NestedAccordion data={fetchedDataFilter?.asset} startDate={startDate} endDate={endDate} menuLabel="Trial Balance"/>
                          
                          // <UpdateTable
                          //   // className="mt-5"
                          //   nodes={fetchedDataFilter?.asset}
                          //   columns={assetColumns}
                          //   subColumn={assetSubColumns}
                          //   handilpagedrop={false}
                          //   subName={"ledgers"}
                          //   subHeader={false}
                          //   tableWidth="50% 25% 25%"
                          //   mobileWidth="50% 25% 25%"
                          //   expand={true}
                          //   headerHide={true}
                          // />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {fetchedDataFilter?.liability?.length ? (
                <div className="ps-4 py-3 dotted-border-y">
                  <div className="d-flex justify-content-between">
                    <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                      Liability
                    </div>
                  </div>
                  <div className="ms-2">
                    <Row className="mt-2 ever-rise-table reportTable trial-table ">
                      <Col xs={12}>
                        {fetchedDataFilter?.liability && (
                          <NestedAccordion data={fetchedDataFilter?.liability} startDate={startDate} endDate={endDate} menuLabell="Trial Balance"/>
                          // <UpdateTable
                          //   nodes={fetchedDataFilter?.liability}
                          //   columns={liabilityColumns}
                          //   subColumn={assetSubColumns}
                          //   handilpagedrop={false}
                          //   subName={"ledgers"}
                          //   subHeader={false}
                          //   tableWidth="50% 25% 25%"
                          //   mobileWidth="50% 25% 25%"
                          //   expand={true}
                          //   headerHide={true}
                          // />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {fetchedDataFilter?.income?.length ? (
                <div className="ps-4 py-3 dotted-border-y">
                  <div className="d-flex justify-content-between">
                    <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                      Income
                    </div>
                  </div>
                  <div className="ms-2">
                    <Row className="mt-2 ever-rise-table reportTable trial-table ">
                      <Col xs={12}>
                        {fetchedDataFilter?.income && (
                          <NestedAccordion data={fetchedDataFilter?.income} startDate={startDate} endDate={endDate} menuLabell="Trial Balance"/>
                          // <UpdateTable
                          //   nodes={fetchedDataFilter?.income}
                          //   columns={incomeColumns}
                          //   subColumn={assetSubColumns}
                          //   handilpagedrop={false}
                          //   subName={"ledgers"}
                          //   tableWidth="50% 25% 25%"
                          //   mobileWidth="50% 25% 25%"
                          //   headerHide={true}
                          //   expand={true}
                          // />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {fetchedDataFilter?.expense?.length ? (
                <div className="ps-4 py-3">
                  <div className="d-flex justify-content-between">
                    <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                      Expense
                    </div>
                  </div>
                  <div className="ms-2">
                    <Row className="mt-2 ever-rise-table reportTable trial-table ">
                      <Col xs={12}>
                        {fetchedDataFilter?.expense && (
                          <NestedAccordion data={fetchedDataFilter?.expense} startDate={startDate} endDate={endDate} menuLabell="Trial Balance"/>
                          // <UpdateTable
                          //   nodes={fetchedDataFilter?.expense}
                          //   columns={expenseColumns}
                          //   subColumn={assetSubColumns}
                          //   handilpagedrop={false}
                          //   subName={"ledgers"}
                          //   tableWidth="50% 25% 25%"
                          //   mobileWidth="50% 25% 25%"
                          //   headerHide={true}
                          //   expand={true}
                          // />
                        )}
                      </Col>
                    </Row>

                    {/* {fetchedData?.opening_balance_difference != 0 ? (
                      <table className="estimation-table trial-balance-total mt-1 remove-tbl-shadow">
                    <tr className="mt-3">
                      <th className="w-50">Opening Balance Difference</th>
                      <th className="w-25 ps-3 text-end pe-5">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              fetchedData?.opening_balance_type == "debit"
                                ? fetchedData?.opening_balance_difference
                                : 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                      <th className="w-25 ps-3 text-end pe-5">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              fetchedData?.opening_balance_type == "credit"
                                ? fetchedData?.opening_balance_difference
                                : 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                    </tr>
                    </table>
                  ) : (
                    <></>
                  )} */}

                    {/* {fetchedData?.opening_balance_difference > 0 && (
                    <table className="estimation-table trial-balance-total mt-1 remove-tbl-shadow">
                      <tr>
                        <th className="w-50">Difference in Opening Balances</th>
                        <th className="w-25">
                          {fetchedData?.opening_balance_type == "debit"
                            ? Number(
                                Number(
                                  fetchedData?.opening_balance_difference
                                ).toFixed(2)
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                              })
                            : "-"}{" "}
                          {fetchedData?.opening_balance_type == "debit"
                            ? "AED"
                            : ""}
                        </th>
                        <th className="w-25">
                          {fetchedData?.opening_balance_type == "credit"
                            ? Number(
                                Number(
                                  fetchedData?.opening_balance_difference
                                ).toFixed(2)
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                              })
                            : "-"}{" "}
                          {fetchedData?.opening_balance_type == "credit"
                            ? "AED"
                            : ""}
                        </th>
                      </tr>
                    </table>
                  )} */}
                  </div>
                </div>
              ) : (
                <></>
              )}
              {!fetchedDataFilter?.asset?.length &&
              !fetchedDataFilter?.liability?.length &&
              !fetchedDataFilter?.income?.length &&
              !fetchedDataFilter?.expense?.length ? (
                <div className="d-flex justify-content-center mt-2">
                  No data available
                </div>
              ) : (
                <table className="estimation-table trial-balance-total">
                  <thead>
                  {fetchedData?.opening_balance_difference != 0 ? (
                    <tr className="">
                      <th className="w-50 py-2">Opening Balance Difference</th>
                      <th className="w-25 ps-3 text-end pe-5 py-2">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              fetchedData?.opening_balance_type == "debit"
                                ? fetchedData?.opening_balance_difference
                                : 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                      <th className="w-25 ps-3 text-end pe-5 py-2">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              fetchedData?.opening_balance_type == "credit"
                                ? fetchedData?.opening_balance_difference
                                : 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                    </tr>
                  ) : (
                    <></>
                  )}
                    <tr>
                      <th className="w-50">Total</th>
                      <th className="w-25 ps-3 text-end pe-5">
                        {NumberFormat(
                          Number(debitTotal ? debitTotal : 0),
                          desimalrange,
                          desimalrange
                        )}
                        {/* {NumberFormat(
                          Number(debitTotal ? debitTotal : 0),
                          desimalrange,
                          desimalrange
                        )} */}
                      </th>
                      <th className="w-25 ps-3 text-end pe-5">
                        {NumberFormat(
                          Number(creditTotal ? creditTotal : 0),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                    </tr>
                  </thead>
                  {/* {fetchedData?.opening_balance_difference != 0 ? (
                    <tr className="mt-3">
                      <th className="w-50">Opening Balance Difference</th>
                      <th className="w-25 ps-3 text-end pe-5">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              fetchedData?.opening_balance_type == "debit"
                                ? fetchedData?.opening_balance_difference
                                : 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                      <th className="w-25 ps-3 text-end pe-5">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              fetchedData?.opening_balance_type == "credit"
                                ? fetchedData?.opening_balance_difference
                                : 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </th>
                    </tr>
                  ) : (
                    <></>
                  )} */}
                </table>
              )}
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TrialBalance
